import { Text } from "@mantine/core";
import { type ReactNode, useCallback } from "react";
import { useSelector } from "src/redux/hooks";

import styles from "./NavigationTile.module.scss";

interface NavigationTileProps {
  title: string;
  description?: string;
  onClick?: () => void;
  disabled?: boolean;
  compact?: boolean;
  children?: ReactNode;
}

const NavigationTile = ({
  title,
  description,
  onClick,
  disabled,
  compact,
  children,
}: NavigationTileProps) => {
  const uppercase = useSelector(state => state.preferencesSlice.uppercase);

  const handleClick = useCallback(() => {
    if (!disabled && onClick) {
      onClick();
    }
  }, [disabled, onClick]);

  const displayTitle = uppercase
    ? (title ?? "").toUpperCase()
    : (title ?? "");

  return (
    <div
      data-cy="card"
      className={`${styles.tile} ${compact ? styles.compact : ""} ${disabled ? styles.disabled : ""}`}
      onClick={handleClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick && !disabled ? 0 : undefined}
      onKeyDown={
        onClick && !disabled
          ? e => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
              }
            }
          : undefined
      }>
      <Text className={styles.title}>{displayTitle}</Text>
      {!compact && <div className={styles.separator} />}
      {description ? (
        <p className={styles.description}>{description}</p>
      ) : null}
      {children ? <div className={styles.footer}>{children}</div> : null}
    </div>
  );
};

export default NavigationTile;
